import { useState } from 'react';
import { makeStyles, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import UserEditModal from './shared/UserModals/UserEditModal';

const useStyles = makeStyles((theme) => ({
  userHeader: {
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    padding: theme.spacing(2),
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  },
  userAvatar: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: 24,
    fontWeight: 'bold',
    flexShrink: 0,
  },
  userDetails: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0, // Important for text truncation to work
    overflow: 'hidden',
  },
  userName: {
    fontSize: 20,
    fontWeight: 600,
    color: '#333',
    marginBottom: 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  userEmail: {
    fontSize: 14,
    color: '#666',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  editIconButton: {
    marginLeft: 'auto',
    color: '#667eea',
    transition: 'all 0.3s',
    '&:hover': {
      color: '#4a5ee8',
      backgroundColor: 'rgba(102, 126, 234, 0.04)',
      transform: 'scale(1.1)',
    },
  },
}));

const UserHeader = ({ userData, onUserUpdate }) => {
  const classes = useStyles();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleOpenEditModal = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = (hasUserBeenUpdated) => {
    setIsEditModalOpen(false);
    if (hasUserBeenUpdated && onUserUpdate) {
      // Refresh user data or handle update
    }
  };

  const handleUserSave = (updatedUserData) => {
    if (onUserUpdate) {
      onUserUpdate(updatedUserData);
    }
  };

  return (
    <div className={classes.userHeader}>
      <div className={classes.userAvatar}>
        {userData?.firstName?.[0]}{userData?.lastName?.[0]}
      </div>
      <div className={classes.userDetails}>
        <div className={classes.userName}>
          {userData?.firstName} {userData?.lastName}
        </div>
        <div className={classes.userEmail}>
          {userData?.email}
        </div>
      </div>
      <IconButton
        className={classes.editIconButton}
        onClick={handleOpenEditModal}
        size="small"
      >
        <EditIcon />
      </IconButton>

      <UserEditModal
        open={isEditModalOpen}
        handleClose={handleCloseEditModal}
        userData={userData}
        onSave={handleUserSave}
      />
    </div>
  );
};

export default UserHeader;
